import moment from 'moment';
import React from 'react';
import { Input, message, Button, DatePicker, Upload, Switch } from 'antd';
import { InboxOutlined, CloseCircleOutlined } from '@ant-design/icons';
import Title from '../../../Components/Common/pageTitle';
import { TableWrapper, TableContainer, Label, ValueBox } from './info.styled';

import axios from '../../../Lib/axios';
import { onEditPopup } from '../../../Lib/Api/app';

export default class PopupInfo extends React.PureComponent {
    state = {
        data: {},
        photo: null, // 이미지 상태 관리
    };

    componentDidMount = () => {
        const { state } = this.props.history.location;
        if (!state || !state.id) return this.props.history.goBack();

        this.fetchInfo(state.id);
    };

    fetchInfo = async id => {
        const { data } = await axios.get('/v1/popup/list/info', {
            params: {
                popupId: id,
            },
        });

        if (!data || data === 'check parameters') {
            return this.props.history.goBack();
        }

        if (data === 'invalid popup') {
            return message.warning('잘못된 게시물 정보입니다.');
        }

        this.setState({ ...data, photo: data.photo });
    };

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSwitchChange = checked => {
        this.setState({ isPublic: checked });
    };

    handleStartDateChange = (date, dateString) => {
        this.setState({ startDate: dateString });
    };

    handleEndDateChange = (date, dateString) => {
        this.setState({ endDate: dateString });
    };

    handleFileChange = ({ file }) => {
        if (file && file.type.startsWith('image/')) {
            this.setState({ photo: file });
        } else {
            message.warning('이미지 파일만 업로드할 수 있습니다.');
        }
    };

    handleRemoveImage = () => {
        this.setState({ photo: null });
    };

    onUpdate = async () => {
        const { isPublic, title, photo, startDate, endDate } = this.state;
        if (!title) return message.warning('제목을 입력해주세요.');

        let img = photo;
        if (typeof photo !== 'string') {
            const formData = new FormData();
            formData.append('photo', photo);
            const header = { headers: { 'Content-Type': 'multipart/form-data' } };
            const { data: image } = await axios.post('/v1/popup/image/upload', formData, header);
            img = image;
        }

        const info = { isPublic, title, photo: img, startDate, endDate };

        onEditPopup({ popupId: this.state._id, info })
            .then(resolve => {
                if (resolve && resolve.data === 'success') {
                    message.success('팝업 게시물 업데이트 완료');
                    setTimeout(() => {
                        this.props.history.goBack();
                    }, 600);
                }
            })
            .catch(error => {
                message.error('서버 장애가 발생하였습니다. 관리자에게 문의해주세요.');
            });
    };

    render() {
        return (
            <>
                <Title title='팝업 게시물 정보' />
                <TableWrapper>
                    <TableContainer>
                        {this.state && (
                            <>
                                <ValueBox>
                                    <Label style={{ fontSize: '14px' }}>
                                        <b>공개 여부</b>
                                    </Label>
                                    <Switch checked={this.state.isPublic} onChange={this.handleSwitchChange} />
                                </ValueBox>

                                <ValueBox>
                                    <Label style={{ fontSize: '14px' }}>
                                        <b>팝업 공개일</b>
                                    </Label>
                                    <DatePicker value={this.state.startDate ? moment(this.state.startDate) : null} onChange={this.handleStartDateChange} />
                                </ValueBox>

                                <ValueBox>
                                    <Label style={{ fontSize: '14px' }}>
                                        <b>팝업 마감일</b>
                                    </Label>
                                    <DatePicker value={this.state.endDate ? moment(this.state.endDate) : null} onChange={this.handleEndDateChange} />
                                </ValueBox>

                                <ValueBox>
                                    <Label style={{ fontSize: '14px' }}>
                                        <b>팝업명</b>
                                    </Label>
                                    <Input placeholder='팝업명을 입력해주세요.' value={this.state.title} name='title' onChange={this.handleChange} />
                                </ValueBox>

                                <ValueBox>
                                    <Label style={{ fontSize: '14px' }}>
                                        <b>팝업 이미지</b>
                                    </Label>
                                    <Upload.Dragger
                                        name='photo'
                                        accept='image/*'
                                        beforeUpload={() => false}
                                        onChange={this.handleFileChange}
                                        showUploadList={false}
                                    >
                                        {this.state.photo ? (
                                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                                <img
                                                    style={{
                                                        width: '300px',
                                                        height: '300px',
                                                        objectFit: 'contain',
                                                        borderRadius: '8px',
                                                    }}
                                                    src={typeof this.state.photo === 'string' ? this.state.photo : URL.createObjectURL(this.state.photo)}
                                                    alt='사진 미리보기'
                                                />
                                                <CloseCircleOutlined
                                                    onClick={e => {
                                                        e.stopPropagation();
                                                        this.handleRemoveImage();
                                                    }}
                                                    style={{
                                                        position: 'absolute',
                                                        top: '10px',
                                                        right: '10px',
                                                        fontSize: '20px',
                                                        color: 'red',
                                                        cursor: 'pointer',
                                                        backgroundColor: 'white',
                                                        borderRadius: '50%',
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <>
                                                <p className='ant-upload-drag-icon'>
                                                    <InboxOutlined />
                                                </p>
                                                <p className='ant-upload-text'>이미지를 여기로 드래그하거나 클릭하여 업로드하세요.</p>
                                            </>
                                        )}
                                    </Upload.Dragger>
                                </ValueBox>

                                <ValueBox>
                                    <Button type='primary' onClick={this.onUpdate}>
                                        현재 상태로 변경 및 저장
                                    </Button>
                                </ValueBox>
                            </>
                        )}
                    </TableContainer>
                </TableWrapper>
            </>
        );
    }
}
